import type { CSSProperties } from "react";

/** Stagger index of the `.mi-rise` entrance animation. */
export const riseStyle = (index: number): CSSProperties =>
  ({ "--mi-index": index }) as CSSProperties;

/** "example.com" from a URL, for compact link labels. */
export const hostOf = (url: string): string => {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
};
